import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reflexiv',
})
export class ReflexivPipe implements PipeTransform {
  transform(value: any, language: string): any {
    if (language == 'en') {
      return value === 'Frau' ? 'she' : 'he';
    } else {
      return value === 'Frau' ? 'ihr' : 'ihm';
    }
  }
}
